<!--
  发票申请审核列表导出（BUG-2026-581958）。

  ## 这一页原来为什么导不出来
  三段里只有后端是好的：
    · 后端 `POST /cust/customerOrder/downloadCustomerOrderInvoiceList` 早就实现了，
      建 sys_task、写 code=`downloadCustomerOrderInvoiceList`、还带导出审计日志；
    · 但列表页的「导出」按钮跳的是 `/export/list?code=InvoiceApplicationAuditExport`
      —— 这个 code **谁也不认**：导出中心按 code 挂子组件，没有它对应的那个（就是本文件，原来不存在）；
      而任务列表又是拿这个 code 去 sys_task 里筛的，后端写进去的却是 `downloadCustomerOrderInvoiceList`，
      两边对不上，于是既没有导出表单、列表也永远是空的；
    · 前端 api 里还留着一个 `createExportTask`，指向 admin-api 根本不存在的路径，零调用。

  所以修的是**前端这两段**：code 统一成后端真正写进 sys_task 的那个字符串，并补上这个子组件。
  ⚠️ 以后再加导出，code 一律以**后端 `dto.setCode(...)` 里的字面量**为准，别另起一个好听的名字 ——
     它同时是"挂哪个表单"和"筛哪些任务"两件事的钥匙，起错名两件事一起坏，而且都是静默的。

  ## 筛选项为什么和列表长得一样
  导出的契约是「导出你在列表上看到的那一批」，所以这里的参数组装**逐字镜像**
  `views/finance/invoiceApplicationAudit/list.vue` 的 doQueryList，包括它那几个 if 的判空写法。

  BUG-2026-448706：列表和导出均传时间类型与范围，1=申请时间，2=审核时间。
  未选择时间类型时默认申请时间；清空时间范围后不限制时间。
-->
<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="申请人信息：">
        <el-input v-model="query.applicantInfo" placeholder="请输入姓名/手机号" size="small" clearable />
      </el-form-item>
      <el-form-item label="申请人身份：">
        <el-select v-model="query.applicantIdentity" placeholder="全部" clearable size="small" style="width: 120px;">
          <el-option v-for="item in identityList" :key="item.id" :label="item.name" :value="item.level" />
        </el-select>
      </el-form-item>
      <el-form-item label="发票类型：">
        <!-- 值对齐后端 customer_order_invoice.type（1普票 2专票），与列表页一致 -->
        <el-select v-model="query.invoiceType" placeholder="全部" clearable size="small" style="width: 140px;">
          <el-option label="电子普通发票" :value="1" />
          <el-option label="增值税专用发票" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="城市公司：">
        <el-input v-model="query.cityCompany" placeholder="请输入城市公司" size="small" clearable />
      </el-form-item>
      <el-form-item label="支付方式：">
        <el-select v-model="query.orderPayType" placeholder="全部" clearable size="small" style="width: 140px;">
          <el-option label="零售价支付" :value="1" />
          <el-option label="余额账户支付" :value="2" />
          <el-option label="积分账户支付" :value="3" />
          <el-option label="赠送账户支付" :value="4" />
          <el-option label="在线支付" :value="5" />
          <el-option label="组合支付" :value="6" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态：">
        <!-- 列表是用 tab 切状态的（activeName → query.state），默认「待审核」；这里做成下拉，值完全相同 -->
        <el-select v-model="query.state" placeholder="请选择" size="small" style="width: 120px;">
          <el-option label="待审核" value="0" />
          <el-option label="开票中" value="1" />
          <el-option label="已开票" value="2" />
          <el-option label="开票失败" value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="时间筛选：">
        <el-select v-model="query.timeType" placeholder="请选择" clearable size="small" style="width: 120px;">
          <el-option label="申请时间" :value="1" />
          <el-option label="审核时间" :value="2" />
        </el-select>
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始" end-placeholder="结束" style="margin-left: 10px;" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleExport" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import invoiceApplicationAuditApi from '@/api/finance/invoiceApplicationAudit'
import { filterEmpty } from '@/utils'

export default {
  data() {
    return {
      identityList: [],
      dateTime: null,
      query: {
        applicantInfo: undefined,
        applicantIdentity: undefined,
        invoiceType: undefined,
        cityCompany: undefined,
        timeType: 1,
        orderPayType: undefined,
        // 与列表默认 tab 一致：待审核
        state: '0'
      }
    }
  },
  created() {
    // 身份下拉与列表页同源（列表页也是从这个缓存里取的）
    this.identityList = JSON.parse(localStorage.getItem('levelList') || '[]')
  },
  methods: {
    /** 逐字镜像 list.vue 的 doQueryList 参数组装，改动时两边一起改 */
    buildParams() {
      const params = { state: this.query.state }
      if (this.query.applicantInfo) {
        params.namePhone = this.query.applicantInfo.trim()
      }
      if (this.query.applicantIdentity !== undefined && this.query.applicantIdentity !== '') {
        params.levelId = this.query.applicantIdentity
      }
      if (this.query.invoiceType !== undefined && this.query.invoiceType !== '' && this.query.invoiceType !== null) {
        params.type = this.query.invoiceType
      }
      if (this.query.orderPayType !== undefined && this.query.orderPayType !== '') {
        params.orderPayType = this.query.orderPayType
      }
      if (this.query.cityCompany) {
        params.cityCompany = this.query.cityCompany
      }
      if (this.dateTime && this.dateTime.length === 2) {
        params.timeType = this.query.timeType || 1
        params.startTime = this.dateTime[0]
        params.endTime = this.dateTime[1]
      }
      return params
    },
    handleExport() {
      return this.$common
        .confirm('是否确认导出')
        .then(() => invoiceApplicationAuditApi.downloadCustomerOrderInvoiceList(filterEmpty(this.buildParams())))
        .then(() => {
          this.$message.success('导出任务已创建')
          // 通知父组件刷新任务列表；任务是异步跑的，创建成功不等于文件已生成
          this.$emit('created')
        })
        .catch(err => {
          if (err === 'cancel') return
          this.$message.error((err && (err.msg || err.message)) || '导出失败')
        })
    }
  }
}
</script>
